import React from "react";
import PageWrapper from "../components/PageWrapper";

// Example screenshots array for giveaway proof; update with your real file paths
const screenshots = [
  "/images/giveaway1.jpg", "/images/giveaway2.jpg", "/images/giveaway3.jpg"
  // Add more if needed
];

// Example winning wallet addresses
const wallets = [
  "0x5AEA...30c0", "0xC4c6...7b95", "0x5503...3a82",
  "0xb0A6...9684", "0xBFaB...193", "0xcd0B...8f0b",
  "0xAF7A...6854", "0x32Ff...4B20", "0xB264...19Ef", "0x1E6c...14dA"
];

export default function Giveaway() {
  return (
    <PageWrapper>
      <div
        style={{
          maxWidth: "900px",
          margin: "auto",
          borderRadius: "32px",
          padding: "32px 18px",
          background: "rgba(0,0,0,0.10)",
          boxSizing: "border-box"
        }}
      >
        <h1 style={{
          fontSize: "2em",
          color: "#FFD700",
          fontWeight: "bold",
          marginBottom: "18px"
        }}>🎁 Giveaway #1 Completed</h1>

        <p style={{
          color: "#fff",
          fontSize: "1.1em",
          marginBottom: "18px",
          lineHeight: "1.7"
        }}>
          We’ve completed our first community giveaway—distributing <b>100,000 MONKZI</b> to each of 10 unique wallet addresses, for a total of <b>1,000,000 MONKZI</b> given away!
        </p>

        <ul style={{
          color: "#FFD700",
          fontSize: "1.08em",
          marginBottom: "16px",
          paddingLeft: "18px"
        }}>
          <li><b>Total Given Away:</b> 1,000,000 MONKZI</li>
          <li><b>Wallets Rewarded:</b> 10</li>
          <li><b>Amount per Wallet:</b> 100,000 MONKZI</li>
        </ul>

        <div style={{
          margin: "18px 0 30px 0",
          background: "rgba(255,247,214,0.10)",
          borderRadius: "14px",
          padding: "14px",
          color: "#fff",
          wordBreak: "break-all"
        }}>
          <b>Winning Wallets:</b>
          <ul style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            margin: "10px 0 0 0",
            padding: 0,
            listStyle: "none"
          }}>
            {wallets.map((w, i) => (
              <li key={i} style={{
                background: "#FFD700",
                color: "#07333c",
                padding: "6px 13px",
                borderRadius: "10px",
                fontFamily: "monospace",
                fontSize: "1em",
                marginBottom: "7px"
              }}>{w}</li>
            ))}
          </ul>
        </div>

        <div style={{ marginBottom: "30px" }}>
          <b style={{ color: "#FFD700" }}>Proof of Giveaway:</b>
          <div style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "12px",
            marginTop: "12px"
          }}>
            {screenshots.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`Giveaway proof #${i + 1}`}
                style={{
                  width: "100%",
                  maxWidth: "150px",
                  borderRadius: "8px",
                  border: "2px solid #FFD700"
                }}
              />
            ))}
          </div>
        </div>

        <a
          href="https://bscscan.com/token/0x3799f998a13bc157e42020305ea4a81bd3ec3d6a"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            background: "#FFD700",
            color: "#07333c",
            fontWeight: "bold",
            fontSize: "1.06em",
            padding: "12px 24px",
            borderRadius: "20px",
            textDecoration: "none",
            boxShadow: "0 4px 20px rgba(246,195,67,0.10)",
            display: "inline-block"
          }}
        >
          🔍 View on BscScan
        </a>

        <div style={{
          color: "#FFD700",
          marginTop: "22px",
          fontWeight: "bold"
        }}>
          More giveaways coming soon—stay tuned!
        </div>
        {/* --- SOCIAL LINKS --- */}
        <div style={{
          marginTop: "38px",
          borderTop: "1.5px solid #404040",
          padding: "24px 0 8px 0",
          textAlign: "center"
        }}>
          <span style={{ fontWeight: "bold", marginRight: "18px", color: "#FFD700" }}>Follow us:</span>
          <a href="https://t.me/monkillaofficial" target="_blank" rel="noopener noreferrer" style={{ color: "#0088cc", margin: "0 14px", fontWeight: "bold" }}>Telegram</a>
          <a href="https://twitter.com/monkillacoin" target="_blank" rel="noopener noreferrer" style={{ color: "#1da1f2", margin: "0 14px", fontWeight: "bold" }}>X (Twitter)</a>
          <a href="https://instagram.com/monkilla.official" target="_blank" rel="noopener noreferrer" style={{ color: "#d6249f", margin: "0 14px", fontWeight: "bold" }}>Instagram</a>
          <a href="https://www.facebook.com/profile.php?id=61578002207190" target="_blank" rel="noopener noreferrer" style={{ color: "#d6249f", margin: "0 14px", fontWeight: "bold" }}>Facebook</a>
		<a href="https://discord.gg/q8MDWV4K" target="_blank" rel="noopener noreferrer" style={{ color: "#d6249f", margin: "0 14px", fontWeight: "bold" }}>Discord</a>
          <a href="mailto:info@monkilla.com" style={{ color: "#FFD700", margin: "0 14px", fontWeight: "bold" }}>Email</a>
        </div>
      </div>
      
      <style>{`
        @media (max-width: 700px) {
          .page-card {
            min-width: 92vw !important;
            max-width: 99vw !important;
            padding: 18px 5vw !important;
          }
        }
      `}</style>
    </PageWrapper>
  );
}
